import { render, staticRenderFns } from "./OrderValidity.vue?vue&type=template&id=397eb3e3&"
import script from "./OrderValidity.vue?vue&type=script&lang=js&"
export * from "./OrderValidity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports